export default __webpack_public_path__ + "static/media/demand.c0978ba0.svg";